import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { NEWSLETTER } from "../../constants/siteTestIds";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterInline = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    try {
      setLoading(true);
      await axios.post(`${API}/newsletter`, { email, name: name || undefined, source: "home_newsletter" });
      toast.success("You're in. Manuel's letter hits inboxes every Sunday at 7am.");
      setEmail(""); setName("");
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="newsletter"
      data-testid={NEWSLETTER.section}
      className="relative bg-[#0a0a0a] py-28 md:py-40 border-t border-black/10"
    >
      <div className="mx-auto max-w-[1100px] px-6 md:px-12 text-center">
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="font-mono-ui text-[11px] tracking-[0.3em] uppercase text-white/70">
          06 — The Sunday Letter
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          className="mt-6 font-display text-white text-[clamp(38px,7vw,88px)] leading-[1] tracking-[-0.02em]">
          A note from Manuel.<br />
          <span className="font-light text-white/55">Every Sunday. 7am.</span>
        </motion.h2>
        <p className="mt-8 max-w-xl mx-auto text-white/65 text-base md:text-lg leading-relaxed">
          One story. One sharp idea. One challenge for the week. Read by 84,000+ founders, fighters and quiet builders.
        </p>
        <form data-testid={NEWSLETTER.form} onSubmit={submit} className="mt-12 max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 sm:gap-6 text-left">
            <div className="sm:col-span-2">
              <input type="text" value={name} onChange={(e)=>setName(e.target.value)}
                className="w-full bg-transparent border-0 border-b border-white/25 text-white placeholder-white/35 py-3.5 focus:outline-none focus:border-white transition-colors"
                placeholder="Your name (optional)" />
            </div>
            <div className="sm:col-span-3">
              <input data-testid={NEWSLETTER.email} type="email" value={email} onChange={(e)=>setEmail(e.target.value)}
                className="w-full bg-transparent border-0 border-b border-white/25 text-white placeholder-white/35 py-3.5 focus:outline-none focus:border-white transition-colors"
                placeholder="you@you.com" required />
            </div>
          </div>
          <div className="mt-10 flex justify-center">
            <button data-testid={NEWSLETTER.submit} type="submit" disabled={loading}
              className="inline-flex items-center gap-2.5 bg-white text-[#0a0a0a] hover:bg-transparent hover:text-white border border-white px-7 py-3.5 font-mono-ui text-[12px] tracking-[0.2em] uppercase transition-all disabled:opacity-50">
              {loading ? "Subscribing..." : "Subscribe — Free"}
              <ArrowRight size={14} />
            </button>
          </div>
        </form>
        <p className="mt-8 font-mono-ui text-[10px] tracking-[0.3em] uppercase text-white/30">— No spam. Unsubscribe with one click.</p>
      </div>
    </section>
  );
};
